import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

const companyMap = {
    "ahmedabad" : "Ahmedabad",
    "rajkot" : "Rajkot",
    "work_from_home": "Work From Home"
}

export const AI_getEmployeeList = apiBase.createListInstance({
    endpoint: "/employee/",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    listPath: "data.rows",
    reduxKey: "employeeData",
    action: "GET_EMPLOYEE_LIST",
    onSuccess: (data) => data.employee_list
});

// for single employee 
export const AI_getEmployee = apiBase.createListInstance({
    endpoint: "/employee/{id}",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "singleEmployeeData",
    action: "GET_EMPLOYEE",
    onSuccess: (data) => data.employee
});


// For update employee details
export const AI_updateEmployee = apiBase.createInstance({
    endpoint: "/employee/{id}",
    method: "put",
    reducer: "employeeReducer",
    reduxKey: "updateEmployeeData",
    action: "UPDATE_EMPLOYEE",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getEmployeeList.updateAction(
            [
                data.employee
            ]
        )
    }
});

// For delete employee details from list
export const AI_deleteEmployee = apiBase.createInstance({
    endpoint: "/employee/{id}",
    method: "delete",
    reducer: "employeeReducer",
    reduxKey: "deleteEmployeeData",
    action: "DELETE_Employee",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getEmployeeList.deleteAction(
            [parseInt(data.deleted_id)]
        )
    }
});

export const AI_uploadImage = apiBase.createInstance({
    endpoint: "/upload-image/{id}",
    method: "put",
    reducer: "employeeReducer",
    reduxKey: "imageUpload",
    action: "UPLOAD_IMAGE",
    middleware : notificationMiddleWare,
    onSuccess: (data) => {
        AI_getEmployeeList.updateAction(
            [
                data.employee
            ]
        )
    },
});

export const AI_technicalEmployeeView = apiBase.createListInstance({
    endpoint: "/technical-employee-view",
    method: "post",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "technicalEmployeeView",
    action: "TECHNICAL_EMPLOYEE_VIEW",
    onSuccess: (data) => {
        return {
            ...data,
            employee :  data.employee.map(a => {
        return {
            ...a,
            location : companyMap[a.location]
        }
    })}}
});

export const AI_projectEmployeeList = apiBase.createListInstance({
    endpoint: "/project-access-employee",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "projectEmployeeList",
    action: "PROJECT_EMPLOYEE_LIST",
});

export const AI_findEmployeeFromEastTimeId = apiBase.createListInstance({
    endpoint: "/find-employee-from-easy-time-id/{id}",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "findEmployeeFromEastTimeId",
    action: "FIND_EMPLOYEE_FROM_EASY_TIME_ID",
    onSuccess : (data) => data.employee
});

export const AI_employeeWithName = apiBase.createListInstance({
    endpoint: "/employee-with-name",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "findEmployeeFromEastTimeId",
    action: "FIND_EMPLOYEE_FROM_EASY_TIME_ID",
    onSuccess : (data) => data.employee
});

export const AI_getCelebration = apiBase.createListInstance({
    endpoint: "/celebration",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "celebrationData",
    action: "GET_CELEBRATION_DATA",
    onSuccess: (data) => data
});


export const AI_getEmployeeByProjectList = apiBase.createListInstance({
    endpoint: "/find-employee-name-from-project",
    method: "get",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "getEmployeeByProjectReducerList",
    action: "GET_EMPLOYEE_LIST_BY_PROJECT",
    onSuccess : (data) => data.employee
});

export const AI_sendNotificationToEmployee = apiBase.createListInstance({
    endpoint: "/send-notification-to-employee",
    method: "post",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "sendNotificationToEmployee",
    action: "SEND_NOTIFICATION_TO_EMPLOYEE",
    middleware : notificationMiddleWare
});

export const AI_addSlackId = apiBase.createInstance({
    endpoint: "/add-slack-id",
    method: "post",
    reducer: "employeeReducer",
    key: "id",
    reduxKey: "addSlackId",
    action: "ADD_SLACK_ID",
    listPath: "data.employee",
    middleware : notificationMiddleWare,
    onSuccess : (data) => AI_technicalEmployeeView.updateAction(data.employee)
});